import React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { Icon } from '@fluentui/react/lib/Icon';

const styles = {
    root: {
        textTransform: "capitalize",
        fontFamily: "Abb Inside",
        position: "absolute",
        top: "0",
        right: "0",
        color: "white",
        height: "32px",
        width: "112px",
        backgroundColor: "#0078d4",
        "&:hover" : {
            backgroundColor: "#0078d4",
        },
    },
    icon: {
        paddingRight: "10px",
    },
};

class ExportButton extends React.Component {   
    render() {
        const CustomIcon = () => <Icon iconName="Installation" className={styles.icon}/>;
        return ( 
                <div>
                    <PrimaryButton
                        className = {styles.root}    
                        onClick = {this.props.onClick}
                        disabled = {this.props.loading}
                    >
                        {this.props.loading && <Spinner size={SpinnerSize.medium} />}
                        {!this.props.loading && <CustomIcon />}
                        {!this.props.loading && <span> Export</span>}
                    </PrimaryButton>
                </div>
            );
    };       
}

export default ExportButton;


// WEBPACK FOOTER //
// ./src/components/Administration/ExportButton.js